import seenThis from "./seen-this";
import tintin from "./tintin";

export default [seenThis, tintin];
